


































































































































































































































































































































































































































































import { computed, defineComponent } from '@vue/composition-api';
import { Dialog, Button } from 'element-ui';

export default defineComponent({
  name: 'Dialog',
  props: {
    // 弹框标题
    dialogTitle: {
      type: String,
      defalut: '',
    },
    // 弹框显示
    show: {
      type: Boolean,
      default: false,
    },
    // 协议类型
    dialogType: {
      type: String,
      default: '',
    },
  },
  components: {
    't-dialog': Dialog,
    't-button': Button,
  },
  setup(props: any, { emit }) {
    // 控制协议弹框显示
    const visible = computed(() => props.show);
    // 调用父组件函数关闭弹框
    const onClose = () => {
      emit('handleClose');
    };
    return { visible, onClose };
  },
});
